import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';

const Exception400 = () => (
  <div>Exception 400</div>
);

export default withStyles(styles)(Exception400);
